/**
 * Returns a "freshness" descriptor for a run timestamp.
 * Used by the Model Explorer to render the "Last Verified" badge that
 * pulses when the run is < 7 days old.
 */
export function freshness(isoString) {
  if (!isoString) return { label: "—", tier: "unknown", days: null };
  const ts = new Date(isoString).getTime();
  if (Number.isNaN(ts)) return { label: "—", tier: "unknown", days: null };
  const days = Math.floor((Date.now() - ts) / 86400000);

  if (days < 0)
    return {
      label: "Verified · future",
      tier: "today",
      days,
      color: "#FF4D00",
    };
  if (days < 1)
    return {
      label: "Verified · today",
      tier: "today",
      days,
      color: "#FF4D00",
      pulse: true,
    };
  if (days === 1)
    return {
      label: "Verified · yesterday",
      tier: "fresh",
      days,
      color: "#FF4D00",
      pulse: true,
    };
  if (days < 7)
    return {
      label: `Verified · ${days}d ago`,
      tier: "fresh",
      days,
      color: "#FF4D00",
      pulse: true,
    };
  if (days < 30)
    return {
      label: `Verified · ${days}d ago`,
      tier: "recent",
      days,
      color: "#00F0FF",
      pulse: false,
    };
  if (days < 180)
    return {
      label: `Verified · ${Math.floor(days / 30)}mo ago`,
      tier: "aging",
      days,
      color: "#A3A3A3",
      pulse: false,
    };
  return {
    label: `Stale · ${Math.floor(days / 30)}mo`,
    tier: "stale",
    days,
    color: "#737373",
    pulse: false,
  };
}
